import { object, string } from 'yup';

export const loginSchema = object().shape({
  email: string().email('Invalid email').required('Email is required'),
  passHash: string().required('Password is required'),
});
